import { Container, Navbar, NavbarBrand } from "react-bootstrap";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { Link } from "react-router-dom";

export default function PhysicianSearch() {
    return (
        <Container>
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3">
                    <Container>
                        <NavbarBrand as={Link} to="/">verifyCERT®</NavbarBrand>
                        <NavbarToggle><span className="navbar-toggler-icon"></span></NavbarToggle>
                    </Container>
                </Navbar>
            </header>
            <div>
                An unexpected error has occurred
            </div>
        </Container>
    );
}